import { quizScoreDisplay } from '@/app/quiz/components/quiz-score-display'
import { floor } from 'lodash'

export const PRACTICE_SCORE_DISPLAY_PRECISION = 1
export const PRACTICE_LEVEL_DISPLAY_PRECISION = 0

export function practiceScoreDisplay(score: number) {
  return quizScoreDisplay(score, PRACTICE_SCORE_DISPLAY_PRECISION)
}

export function practiceLevelDisplay(level: number) {
  return floor(level * 100, PRACTICE_LEVEL_DISPLAY_PRECISION)
}
